import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { SearchBar, Icon, Select, Button } from 'components';
import { useDebounce, useBreakpoint } from 'hooks';
import { LayoutContext } from 'contexts';
import {
  Button as ButtonV2,
  Icon as IconV2,
  Text,
} from '@bb/elements-web-rebranding';
import { featureEnabled } from 'utils';
import { StyledHavesWantsSearchWrapper } from './StyledSearchComponents';
import MyBrokerageContext from '../MyBrokerageContext';
import { SearchComponentType } from '../types';

const HavesWantsSearch: SearchComponentType = React.forwardRef((props, ref) => {
  const { siderCollapsed } = React.useContext(LayoutContext);
  const { setQueryData, queryData, locations, loading } =
    React.useContext(MyBrokerageContext);
  const { md, xl } = useBreakpoint();

  const [localSearchTerm, setLocalSearchTerm] = React.useState(
    queryData.searchTerm,
  );
  const debouncedTerm = useDebounce(localSearchTerm, 500);
  const componentDidMount = React.useRef(false);

  const getHandleChange = (key: keyof typeof queryData.searchOptions) => {
    type OnChangeType<T> = (value: T) => void;
    type Value = (typeof queryData.searchOptions)[typeof key];

    const onChange: OnChangeType<Value> = value => {
      const changes = { [key]: value };
      setQueryData(prev => ({
        ...prev,
        pageNumber: 0,
        searchOptions: {
          ...prev.searchOptions,
          ...changes,
        },
      }));
    };
    return onChange;
  };

  React.useEffect(() => {
    if (!componentDidMount.current) {
      componentDidMount.current = true;
      return;
    }
    setQueryData(prev => ({ ...prev, searchTerm: debouncedTerm }));
  }, [debouncedTerm]);

  const { havesWantsLocation, subject } = queryData.searchOptions;

  return (
    <StyledHavesWantsSearchWrapper
      $wrap={!xl}
      $stretch={!md}
      $singleColumn={!siderCollapsed && !md}
    >
      <SearchBar
        value={localSearchTerm}
        onChange={setLocalSearchTerm}
        loading={loading}
        allowClear
        ref={ref}
        placeholder="Search Notes"
        shape="round"
      />
      <Select
        placeholder="Select Subject"
        value={subject}
        onChange={getHandleChange('subject')}
        options={[
          'All',
          'Property',
          'Short Term Lease',
          'Lease',
          'Service Provider',
          'Interested Seller',
          'Open House Help',
          'Miscellaneous',
        ].map(label => ({ label, value: label }))}
      />
      <Select
        placeholder="Select Branch"
        value={havesWantsLocation}
        onChange={getHandleChange('havesWantsLocation')}
        options={[
          { value: 'All', label: 'All' },
          ...locations.map(location => ({
            label: location.name,
            value: location.name,
            idx: location.idx,
          })),
        ]}
      />
      <RouterLink to="/needs/new">
        {featureEnabled('supraRebrandingFeature', 1) ? (
          <ButtonV2
            dataCy="add-needs-button"
            size="small"
            styleOverride={{ minWidth: 'auto' }}
          >
            <IconV2 icon="plusOutlined" color="white" />
            <Text color="white">Add</Text>
          </ButtonV2>
        ) : (
          <Button
            type="primary"
            icon={<Icon type="plus" color="white" width={16} />}
          >
            Add
          </Button>
        )}
      </RouterLink>
    </StyledHavesWantsSearchWrapper>
  );
});

export default HavesWantsSearch;
